@if (column().fieldName === "email") {
    {{ data()[column().fieldName] }}
}
@if (column().fieldName === "publishedState") {
    @if (data()[column().fieldName] === PublishedState.notPublished) {
        {{ "non_published" | translate }}
    } @else {
        {{ "published" | translate }}
    }
}
@if (column().fieldName === "target") {
    @if (data()["measurementUnit"] === Constants.MEASUREMENT.PERCENTAGE) {
        @if (AdaaHelper.isDefined(data()[column().fieldName])) {
            {{ getNumberValue(column().fieldName) | percentageValue: 2 : "" : "%" : true : true }}
        }
    } @else {
        {{ getNumberValue(column().fieldName) | roundValue: 2 : "" : true }}
    }
}
@if (column().fieldName === "annualTarget" || column().fieldName === "visionTarget") {
    {{ getNumberValue(column().fieldName) }}
}
@if (column().fieldName === "annualOptimalPerformance") {
    <span [class]="'badge rounded-1' + ' bg-' + data()['annualOptimalPerformanceColor']">
        @if (AdaaHelper.isDefined(data()[column().fieldName])) {
            {{ getNumberValue(column().fieldName) | percentageValue: 2 : "" }}
        }
    </span>
}
@if (column().fieldName === "comments" || column().fieldName === "categorizedComments") {
    @for (item of getArrayValue("categorizedComments"); track $index) {
        @if (!isCommentEmpty(item)) {
            <div class="card rounded-1 w-auto bg-card comment">
                {{ item.comments }}

                <span class="badge badge-sm w-auto text-white bg-primary fw-bold rounded-0" data-comment>
                    {{ item | translateToken: "categoryName" }}
                </span>
            </div>
        }
    }
    @if (!isCommentEmpty(data())) {
        <div class="card rounded-1 w-auto bg-card comment comment--other">{{ data().comments }}</div>
    }
}
@if (column().fieldName === "status") {
    @if (data().status === "FINISHED") {
        <span class="adaa-icon-active"></span>
    } @else if (data().status === "STOPPED") {
        <span class="adaa-icon-bounded fs-5"></span>
    } @else if (data().status === "INPROGRESS") {
        <i class="fa-solid fa-circle-play"></i>
    } @else if (data().status === "FAILED") {
        <span class="adaa-icon-delete fs-4 text-danger"></span>
    }
}
@if (column().fieldName === "attachDate") {
    {{ data()[column().fieldName] ? (getNumberValue(column().fieldName) | date: Constants.yearDate) : "" }}
}
@if (column().fieldName === "formula") {
    {{ data()[column().fieldName] === "NOFORMULAV" ? ("kpi.NOFORMULAV" | translate) : data()[column().fieldName] }}
}

<!-- Metric Edit List -->
@if (
    column().fieldName === "periodDate" ||
    column().fieldName === "syncDate" ||
    column().fieldName === "conversionPeriod" ||
    ((column().fieldName === "startDate" || column().fieldName === "endDate") &&
        configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.ENTITY_DATA_SYNC_LOGS)
) {
    {{ data()[column().fieldName] ? (getNumberValue(column().fieldName) | date: Constants.shortMonthYearDate : Constants.uaeTimezone) : "" }}
}
@if (column().fieldName === "attachmentFilename" && data().attachmentId) {
    <button class="btn btn-link" (click)="filesApiService.save($any(data().attachmentId), $any(data().attachmentFilename), true)">
        {{ data()[column().fieldName] }}
    </button>
}
@if (column().fieldName.includes("name") && column().fieldName !== "attachmentFilename") {
    <p class="mb-1">{{ data()[column().fieldName] }}</p>

    @if (configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.ACTIVITY_CARD_OPMKPI && !isActivitiesViewPage()) {
        <p class="m-0">
            <span>
                {{ "data_entry.target" | translate }} : {{ AdaaHelper.isDefined(data().target) ? ($any(data().target) | roundValue) : "-" }}
            </span>

            <span class="mx-1">&nbsp;</span>

            <span>
                {{ "data_entry.actual" | translate }} : {{ AdaaHelper.isDefined(data().actual) ? ($any(data().actual) | roundValue) : "-" }}
            </span>
        </p>
    }
    @if (configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.INITIATIVE_CARD_ACTIVITIES) {
        <p class="m-0">
            <span> {{ "common.form.label.start_date" | translate }} : {{ $any(data().startDate) | date: Constants.normalDate }} </span>

            <span class="mx-1">&nbsp;</span>

            <span> {{ "common.form.label.end_date" | translate }} : {{ $any(data().endDate) | date: Constants.normalDate }} </span>
        </p>
    }
}

<!--Export/Import Plan Status-->
@if (column().fieldName === "impextStatus") {
    @if (data()[column().fieldName] === ImportExportStatus.DONE) {
        {{ "importExport.file_status.done" | translate }}
    } @else if (data()[column().fieldName] === ImportExportStatus.FAIL) {
        {{ "importExport.file_status.fail" | translate }}
    } @else if (data()[column().fieldName] === ImportExportStatus.SUCCESS) {
        {{ "importExport.file_status.success" | translate }}
    } @else if (data()[column().fieldName] === ImportExportStatus.PENDING) {
        {{ "importExport.file_status.pending" | translate }}
        <div class="mx-2 zsk__loader zsk__loader--xs"></div>
    }
}

<!--Export/Import Plan Type-->
@if (column().fieldName === "type" && configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.IMPORT_EXPORT) {
    @if (data()[column().fieldName] === ImportExportType.IMPORT) {
        {{ "importExport.operation_type.import" | translate }}
    } @else if (data()[column().fieldName] === ImportExportType.EXPORT) {
        {{ "importExport.operation_type.export" | translate }}
    }
}
@if (
    (column().fieldName === "value" && configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.FORECASTED_VALUES_METRICS_EDITOR_LIST) ||
    (column().fieldName === "actual" && configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.DATA_ENTRY_METRICS_LIST) ||
    (column().fieldName === "actualSynced" && configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.DATA_ENTRY_MONITORING_METRICS_LIST) ||
    (column().fieldName === "actual" && configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.DATA_ENTRY_MONITORING_METRICS_LIST)
) {
    {{ getNumberValue(column().fieldName) | numberComma }}
}
@if (column().fieldName === "manualEntry" && configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.DATA_ENTRY_MONITORING_METRICS_LIST) {
    {{ data()["actualOverride"] ? (getNumberValue("actual") | numberComma) : "-" }}
}
@if (
    column().fieldName === "projectStatus" &&
    (configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.M1_PROJECTS_LIST || configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.PROJECTS_LIST)
) {
    <span class="badge rounded-1" [style.background-color]="statusLabel?.color">
        @if (AdaaHelper.isDefined(data()[column().fieldName])) {
            {{ statusLabel?.label | translate }}
        }
    </span>
}
@if (column().fieldName === "status" && configKey() === Constants.MAIN_TABLE_LIST_CONF_KEY.EMPLOYEE_PULSE_LOGS) {
    @let status = data()[column().fieldName];
    @if (status === EmployeePulseUploadStatus.PROCESSING) {
        <div class="mx-2 zsk__loader zsk__loader--xs"></div>
    } @else {
        {{ "employee_pulse.manage.status." + status | translate }}
    }
}
